<template>
  <AppDialog
    :title="dialogTitle"
    class="archive-offer-dialog archive-offer-discount-dialog"
    position="centered"
    show
    @close="closeDialog"
  >
    <div id="discount-offer-illustration">
      <img
        v-if="!discount_accepted"
        class="illustration"
        :src="DISCOUNT_OFFER_ILLUSTRATION"
      />
      <img
        v-else
        class="illustration"
        :src="DISCOUNT_ACCEPTED_ILLUSTRATION"
      />
    </div>
    <div
      v-if="!discount_accepted"
      class="modal-body"
    >
      <p class="subtitle">We'd hate to see you go! As a thank-you for being with us, we’re offering 50% off your plan for the next 6 months — no strings attached.</p>
      <div class="offer">
        <div class="plans">
          <div class="plan current-plan">
            <div class="plan-name">{{ currentPlanInfo?.name }} price</div>
            <div class="plan-price">${{ currentPlanInfo?.price }}</div>
            <div class="plan-price-period">/seat/mo</div>
          </div>
          <span class="arrow hi-thin-right-arrow"></span>
          <div class="plan discounted-plan">
            <div class="plan-name">Discounted for 6 months</div>
            <div class="plan-price">${{ (currentPlanInfo?.price / 2).toFixed(2) }}</div>
            <div class="plan-price-period">/seat/mo</div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="modal-body"
    >
      <p class="subtitle">You're all set with a 50% discount for the next 6 months.</p>
    </div>
    <div
      v-if="!discount_accepted"
      class="modal-footer"
    >
      <a
        class="btn btn-primary"
        @click="acceptOffer"
      >
        Get 50% off of your plan
      </a>
      <a
        href="#"
        @click="next"
      >
        Continue to {{ cta }}
      </a>
    </div>
    <div
      v-else
      class="modal-footer"
    >
      <a
        class="btn btn-primary"
        @click="closeDialog"
      >
        Close
      </a>
    </div>
  </AppDialog>
</template>

<script>
import AppDialog from '~/components/AppDialog.vue';
import { DISCOUNT_OFFER_ILLUSTRATION, DISCOUNT_ACCEPTED_ILLUSTRATION } from '~/rails_assets.js';
import { OrganizationsResource, AnalyticsResource } from '~/resources';

export default {
  name: 'ArchiveOfferDiscountDialog',
  components: {
    AppDialog,
  },
  props: {
    currentPlan: {
      type: String,
      required: true,
    },
    currentPlanDetails: {
      type: Object,
      required: false,
      default: null,
    },
    organizationId: {
      type: Number,
      required: true,
    },
    plans: {
      type: Array,
      required: true,
    },
    coupon: {
      type: String,
      required: true,
    },
    action: {
      type: String,
      default: 'archive'
    },
    source: { type: String, default: null },
  },
  data: () => ({
    DISCOUNT_OFFER_ILLUSTRATION,
    DISCOUNT_ACCEPTED_ILLUSTRATION,
    discount_accepted: false,
  }),
  computed: {
    dialogTitle() {
      return this.discount_accepted
        ? 'Enjoy your discount!'
        : 'Get 50% off your plan for 6 months 🚀';
    },
    currentPlanInfo() {
      if (this.currentPlanDetails) {
        return this.currentPlanDetails;
      }

      return this.plans.find((plan) => plan?.tier_title === this.currentPlan || plan?.name === this.currentPlan);
    },
    cta() {
      return this.action === 'archive'
        ? 'archiving and cancelling your subscription'
        : 'cancelling your subscription';
    },
  },
  created() {
    this.trackEvent('Archival discount offer viewed');
  },
  methods: {
    async acceptOffer() {
      const payload = {
        token: this.coupon,
      };

      try {
        const response = await OrganizationsResource.applyCoupon({ id: this.organizationId }, payload);

        if (response && response.success) {
          this.discount_accepted = true;
          this.trackEvent('Archival discount offer accepted');
        } else {
          this.$appMessage('Failed to apply discount. Please try again later.');
        }
      } catch (error) {
        if (![401, 403].includes(error.status)) {
          this.$appMessage('Unhandled error. Please try again.');
        }
      }
    },
    next(event) {
      return this.$emit('next', event);
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    trackEvent(name, properties = {}) {
      AnalyticsResource.create(null, {
        event_name: name,
        event_properties: {
          organization_id: this.organizationId,
          discount_type: 'VSMB',
          ...(this.source && { source: this.source }),
          ...properties
        },
      });
    },
  },
};
</script>
